import type React from 'react';

import { Link } from '@change/ds-core-ui';

type Props = {
	href: string;
	children: React.ReactNode;
};

/**
 * Same-tab staff link. `variant="inherit"` opts out of the ds Link's visited color; the color comes from the list item instead.
 */
export const StaffDrawerLink: React.FC<Props> = ({ href, children }) => (
	<li className="text-typography-interactive hover:text-typography-interactive-hover w-fit">
		<Link href={href} size="small" variant="inherit">
			{children}
		</Link>
	</li>
);
